export const GHAZIPUR_PINCODES = [
  '232325', '232326', '232327', '232328', '232329', '232330',
  '232331', '232332', '232333', '232336', '232339', '232340',
  '233001', '233002', '233221', '233222', '233223', '233224',
  '233225', '233226', '233227', '233228', '233229', '233230',
  '233231', '233232', '233233', '233300', '233301', '233302',
  '233303', '233304', '233305', '233306', '233307', '233310',
  '233311', '275201', '275202', '275203', '275204', '275205',
];

export const VARANASI_PINCODES = [
  '221001', '221002', '221003', '221004', '221005', '221006',
  '221007', '221008', '221010', '221011', '221101', '221102',
  '221103', '221104', '221105', '221106', '221107', '221108',
  '221109', '221110', '221111', '221112', '221115', '221116',
  '221201', '221202', '221204', '221206', '221207', '221208',
  '221302', '221305', '221306', '221307', '221311', '221313',
  '221403', '221405',
];

export const LUCKNOW_PINCODES = [
  '226001', '226002', '226003', '226004', '226005', '226006',
  '226007', '226008', '226009', '226010', '226011', '226012',
  '226013', '226014', '226015', '226016', '226017', '226018',
  '226019', '226020', '226021', '226022', '226023', '226024',
  '226025', '226026', '226027', '226028', '226029', '226030',
  '226031', '226101', '226102', '226103', '226104', '226201',
  '226202', '226203', '226301', '226302', '226303', '226401',
  '226501',
];

export const ALLOWED_LISTING_PINCODES = new Set([
  ...GHAZIPUR_PINCODES,
  ...VARANASI_PINCODES,
  ...LUCKNOW_PINCODES,
]);

/**
 * Same pincodes as an array, for `.in('pincode', ...)` filters. Buyers only
 * see listings inside the service area; the mobile app applies the same list.
 */
export const SERVICE_AREA_PINCODES = [...ALLOWED_LISTING_PINCODES];

export const LISTING_PINCODE_ERROR_MESSAGE =
  'Property listing is only allowed in our active service pincodes (Ghazipur, Varanasi, Lucknow).';

export const extractPincode = (value) => {
  if (!value || !String(value).trim()) return null;
  const trimmed = String(value).trim();
  if (/^\d{6}$/.test(trimmed)) return trimmed;
  const match = trimmed.match(/\b(\d{6})\b/);
  return match ? match[1] : null;
};

export const isAllowedPincode = (pincodeOrAddress) => {
  const pincode = extractPincode(pincodeOrAddress);
  return pincode != null && ALLOWED_LISTING_PINCODES.has(pincode);
};
